import { render, staticRenderFns } from "./RemotepayManager.vue?vue&type=template&id=5721647f&"
import script from "./RemotepayManager.vue?vue&type=script&lang=js&"
export * from "./RemotepayManager.vue?vue&type=script&lang=js&"
import style0 from "./RemotepayManager.vue?vue&type=style&index=0&id=5721647f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports